<template>
    <div>
        <!-- Section header -->
        <div class="dashboard-section-header mb-3 mt-5">
            <div class="d-flex align-items-center gap-2">
                <img :src="iconSpecialOk" alt="" class="dashboard-section-header__icon">
                <span class="dashboard-section-header__title">{{ $t('cert.myCertificates') }}</span>
                <span class="count-badge ms-2">{{ totalCount }}</span>
            </div>
            <router-link :to="{ name: 'CertList' }" class="dashboard-show-all">
                {{ $t('cert.viewAll') }}
                <i class="bi bi-chevron-right dashboard-show-all__chevron"></i>
            </router-link>
        </div>

        <!-- Loading -->
        <Skeletor v-if="loading" />

        <!-- Empty state -->
        <div v-if="!loading && !certsList.length" class="text-muted" style="font-size: 14px;">
            {{ $t('general.noRecord') }}
        </div>

        <!-- List -->
        <div v-if="!loading && certsList.length" class="cert-list mb-5">
            <div
                class="cert-list__row"
                v-for="cert in certsList.slice(0, 5)"
                :key="cert.uuid"
            >
                <!-- Icon -->
                <div class="cert-list__icon-wrap">
                    <img :src="iconFile" alt="" class="cert-list__file-icon">
                </div>

                <!-- Name -->
                <div class="cert-list__col">
                    <span class="cert-list__label">{{ $t('cert.certName') }}</span>
                    <span class="cert-list__value">{{ cert.name }}</span>
                </div>

                <!-- Created -->
                <div class="cert-list__col cert-list__col--date">
                    <span class="cert-list__label">{{ $t('cert.created') }}</span>
                    <span class="cert-list__value">{{ formatDateShort(cert.created_at) }}, {{ formatTime(cert.created_at) }}</span>
                </div>

                <!-- Badge -->
                <div v-if=false class="cert-list__badge-col">
                    <div class="shared-cert-badge shared-cert-badge--ok">
                        <i class="bi bi-check-lg shared-cert-badge__icon"></i>
                        <span>No changes</span>
                    </div>
                </div>

                <!-- Action -->
                <div class="cert-list__action">
                    <span
                        v-if="['link', 'logged'].includes(cert.file?.sharing_settings?.mode)"
                        class="cert-list__sharing-icon"
                        :style="{ maskImage: `url(${iconSharingChain})`, webkitMaskImage: `url(${iconSharingChain})` }"
                    ></span>
                    <router-link
                        class="btn cert-list__view-btn"
                        :to="{ name: 'CertDetail', params: { uuid: cert.uuid } }"
                    >
                        {{ $t('cert.viewCertificate') }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http';
import iconFile from '/public/img/new-design/icons/file.svg';
import iconSpecialOk from '/public/img/new-design/icons/special-ok-icon.svg';
import iconSharingChain from '/public/img/new-design/icons/sharing_chain.svg';

export default {
    mounted() {
        this.getCertsList();
        let self = this;
        this.emitter.on('certAdded', (newCert) => {
            self.certsList.unshift(newCert);
        });
    },

    data() {
        return {
            certsList: [],
            totalCount: 0,
            loading: true,
            iconFile,
            iconSpecialOk,
            iconSharingChain,
        };
    },

    methods: {
        getCertsList() {
            let self = this;
            http.get('/certs/list').then((response) => {
                self.certsList = response.data.userCerts;
                self.totalCount = response.data.meta?.totalRecordsCount ?? response.data.userCerts.length;
                self.loading = false;
            });
        },

        formatDateShort(dateStr) {
            const d = new Date(dateStr);
            const days = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];
            return `${days[d.getDay()]} ${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
        },

        formatTime(dateStr) {
            const d = new Date(dateStr);
            const pad = n => String(n).padStart(2, '0');
            return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },
    },
};
</script>